import { render, staticRenderFns } from "./detail_a.vue?vue&type=template&id=bba9f01a"
import script from "./detail_a.vue?vue&type=script&lang=js"
export * from "./detail_a.vue?vue&type=script&lang=js"
import style0 from "./detail_a.vue?vue&type=style&index=0&id=bba9f01a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports